import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "root",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('div', {
    staticClass: "site-carousel__item__inner"
  }, [_c('span', {
    staticClass: "site-carousel__item__loader"
  }, [_c('CircularLoader', {
    attrs: {
      "color": _vm.loaderColor,
      "size": "3rem"
    }
  })], 1), _vm._v(" "), _vm.hasUrl ? _c('a', _vm._b({
    staticClass: "site-carousel__item__link",
    attrs: {
      "id": _vm.id,
      "href": _vm.bannerUrl,
      "target": "_blank",
      "rel": "noopener ugc",
      "tabindex": "0"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event, _vm.banner);
      },
      "dragstart": function ($event) {
        $event.preventDefault();
      },
      "focus": function ($event) {
        return _vm.$emit('focus');
      }
    }
  }, 'a', _vm.$attrs, false), [_c('CarouselItemImg', {
    ref: "image",
    attrs: {
      "media-item": _vm.media,
      "alt": _vm.banner.image_alt,
      "can-load-images": _vm.canLoadImages
    },
    on: {
      "load": _vm.imageLoaded
    }
  })], 1) : _c('div', _vm._b({
    staticClass: "site-carousel__item__link",
    attrs: {
      "id": _vm.id,
      "tabindex": "0"
    },
    on: {
      "focus": function ($event) {
        return _vm.$emit('focus');
      }
    }
  }, 'div', _vm.$attrs, false), [_c('CarouselItemImg', {
    ref: "image",
    attrs: {
      "media-item": _vm.media,
      "alt": _vm.banner.image_alt,
      "can-load-images": _vm.canLoadImages
    },
    on: {
      "load": _vm.imageLoaded
    }
  })], 1)])]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-10be0132";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var CarouselItem = __vue_component__;
export { CarouselItem as default };